import { createContext } from 'react';
import { staticLang } from './format-message';
export default /*#__PURE__*/createContext({
  currentLang: staticLang.current,
  formatMessage: function formatMessage(_ref) {
    var id = _ref.id,
        values = _ref.values;

    if (!values || !Object.keys(values).length) {
      return id;
    }

    return id.replaceAll(/\{(.+?)\}/g, function (_, name) {
      return values[name];
    });
  }
});